/**
/**
 * interfaceApi 用于 API 接口参数统一封装返回
 */
import commonFunc from './common.js'

// 资讯列表接口设置
function setNewsInterface (typeVal, condition) {
    let list = {}
    switch (typeVal) {
        //获得附注汇总表
        case 'getExportTotalTable':
            list = {
                'periodName': condition.periodName,
                'ouName': condition.ouName,
                'intercompanyFlag': condition.intercompanyFlag,
                'discountCurrency': condition.discountCurrency
            }
        break
        //PO重分类
        case 'getPOList'://PO接收查询
            list = {
                'leaseItemNumber': condition.leaseItemNumber,
                'ouName': condition.ouName,
                'periodName': condition.periodName,
                'accountingPeriod': condition.accountingPeriod,
                'poStatus': condition.poStatus,
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize
            }
        break
        case 'POSubmit'://PO提交
            list = {
                'leaseItemNumber': condition.leaseItemNumber,
                // 'periodName': condition.periodName,
                'costReclassificationId': condition.costReclassificationId
            }
        break
        case 'deletePOReceive'://PO删除
            list = {
                'costReclassificationIds': condition.costReclassificationIds
            }
        break

        //报表
        case 'getReportParamByCode'://通过报表的code拿参数
            list = {
                'tableCode': condition.tableCode
            }
        break 
        case 'reportValidData'://验证报表数据
            list = {
                'tableCode': condition.tableCode,
                'param': condition.param
            }
        break

        //操作界面 
        case 'getOperateList': //查询操作列表
            list = {
                'ouName': condition.ouName,
                'leaseItemNumber': condition.leaseItemNumber,
                'leaseItemStatus': condition.leaseItemStatusFlag ? condition.leaseItemStatusFlag : condition.leaseItemStatus,
                'leaseDateBegin': condition.leaseDate ? (condition.leaseDate[0] ? condition.leaseDate[0] : '') : '',
                'leaseDateEnd': condition.leaseDate ? (condition.leaseDate[1] ? condition.leaseDate[1] : '') : '',
                'contractNumber': condition.contractNumber,
                'transactionType': condition.transactionTypeFlag ? condition.transactionTypeFlag : condition.transactionType,
                'leaseItemCategory': condition.leaseItemCategory,
                'uploader': condition.uploader,
                'epoFinanceBp': condition.epoFinanceBp,
                'originalLeaseItemNumber': condition.originalLeaseItemNumber,
                'source': condition.source,
                'leaseItemDescription': condition.leaseItemDescription,
                'uploadedType': condition.uploadedType,
                'exemptionFlag': condition.exemptionFlag,
                'earlyTerminateFlag': condition.earlyTerminateFlag,
                'earlyTerminateStatus': condition.earlyTerminateStatusFlag ? condition.earlyTerminateStatusFlag : condition.earlyTerminateStatus,
                'costCenter': condition.costCenter,
                'poNumber': condition.poNumber,
                'referenceContractNumber': condition.referenceContractNumber,
                'contractStartDate': condition.contractDate ? (condition.contractDate[0] ? condition.contractDate[0] : '') : '',
                'contractEndDate': condition.contractDate ? (condition.contractDate[1] ? condition.contractDate[1] : '') : '',
                'originalItemNumber': condition.originalItemNumber,
                'leaseItemType': condition.leaseItemType,
                'revaluationDate': condition.revaluationDate,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break

        //操作
        case 'handleOperatePage':
            list = {
                'headerIds': condition.headerIds,
                'headerId': condition.headerId,
                'rejectReason': condition.rejectReason,
                'leaseItemNumber': condition.leaseItemNumber,
                'originalLeaseItemNumber': condition.originalLeaseItemNumber,
                'periodName': condition.periodName,
                'operatingUnit': condition.operatingUnit,
                'ouName': condition.ouName,
            }
        break 
        //租金信息详情
        case 'getDetailLeaseInfo': 
            list = {
                'headerId' : condition.headerId,
                'leaseItemNumber' : condition.leaseItemNumber,
                // 'type': condition.type
            }
        break

        //EPO租金信息详情
        case 'getDetailEPOLeaseInfo': 
            list = {
                'headerId' : condition.headerId,
            }
        break

        //会计分录
        case 'getAccountingList': 
        list = {
                'primaryLedger' : condition.primaryLedger,
                'postPeriodName' : condition.postPeriodName,
                'leaseItemNumber': condition.leaseItemNumber,
                'sceneType': condition.sceneType,
                'voucherSceneType': condition.voucherSceneType,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break 
        //会计分录详情
        case 'getAccountingLineList': 
        list = {
                'primaryLedger' : condition.primaryLedger,
                'journalHeaderId' : condition.journalHeaderId,
                'leaseItemNumber': condition.leaseItemNumber,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break

        //值集配置
        case 'getValueSetList': //查询值集列表
            list = {
                'keyName': condition.keyName,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        case 'addValueSet': //新增值集
            list = {
                'valuesetName': condition.valuesetName,
                'valuesetCode': condition.valuesetCode,
                'enableFlag': condition.enableFlag,
                'fixedFlag': condition.fixedFlag
            }
        break
        case 'modifyValueSet': //修改值集
            list = {
                'valuesetId': condition.valuesetId,
                'valuesetName': condition.valuesetName,
                'valuesetCode': condition.valuesetCode,
                'enableFlag': condition.enableFlag,
                'fixedFlag': condition.fixedFlag
            }
        break
        case 'deleteValueSet': //删除值集
            list = {
                'valuesetIds': condition.valuesetIds
            }
        break
        case 'getValueSetLineList': //查询值集列表
            list = {
                'valuesetId': condition.valuesetId,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        case 'addValueSetLine': //新增值集
            list = {
                'valuesetId': condition.valuesetId,
                'valuesetLineContent': condition.valuesetLineContent,
                'valuesetLineCode': condition.valuesetLineCode,
                'valuesetLineProperty': condition.valuesetLineProperty,
                'enableFlag': condition.enableFlag
            }
        break
        case 'modifyValueSetLine': //修改值集
            list = {
                'valuesetId': condition.valuesetId,
                'valuesetLineId': condition.valuesetLineId,
                'valuesetLineContent': condition.valuesetLineContent,
                'valuesetLineCode': condition.valuesetLineCode,
                'valuesetLineProperty': condition.valuesetLineProperty,
                'enableFlag': condition.enableFlag
            }
        break
        case 'deleteValueSetLine': //删除值集
            list = {
                'valuesetLineIds': condition.valuesetLineIds
            }
        break
        case 'getValueSetLineByCode': //查询值集行列表通过值集code
            list = {
                'valuesetCode': condition.valuesetCode,
            }
        break 
        case 'getDicLineByCode': //查询数据字典列表通过code
            list = {
                'dicCode': condition.dicCode,
            }
        break 

        case 'getYearList': //查询财年列表
            list = {
                'primaryLedgerId': condition.primaryLedgerId,//账套id
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break 
        case 'getFiscalYear': //获得财年下的起始月
            list = {
                'primaryLedgerId': condition.primaryLedgerId,//账套id
            }
        break 
        case 'addYear': //新增财年
            list = {
                'primaryLedgerId': condition.primaryLedgerId,//账套id
                'fiscalYear': condition.fiscalYear,
                'startDate': condition.startDate,
                'periodStatus': condition.periodStatus
            }
        break 
        case 'deleteYear': //删除财年
            list = {
                'primaryLedgerId': condition.primaryLedgerId,//账套id
                'periodIds': condition.periodIds, //财年Id
            }
        break
        case 'getYearPeriodList': //查询财年期间列表
            list = {
                'primaryLedgerId': condition.primaryLedgerId,//账套id
                'periodId': condition.periodId  //财年id
            }
        break 
        case 'modifyYearPeroid': //修改期间状态
            list = {
                'periodId': condition.periodId,//期间id
                'periodStatus': condition.periodStatus 
            }
        break  

        case 'getDataList': //查询数据权限列表
            list = {
                'account': condition.account,
                'primaryLedger': condition.primaryLedger,
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize,
            }
        break 
        case 'addData': //新增数据权限
            list = {
                'accountId': condition.accountId,
                'primaryLedger': condition.primaryLedger,
                // 'secondaryLedger': condition.secondaryLedger
            }
        break 
        case 'modifyData': //修改数据权限
            list = {
                'accountId': condition.accountId,
                'primaryLedger': condition.primaryLedger,
                // 'secondaryLedger': condition.secondaryLedger,
                'dataPermissionId': condition.dataPermissionId
            }
        break 
        case 'deleteData': //删除数据权限
            list = {
                'dataPermissionIds': condition.dataPermissionIds
            }
        break 

        case 'addDataDic': //新增数据字典
            list = {
                // 'dicCode': condition.dicCode,
                'dicName': condition.dicName,
                'dicParentCode': condition.dicParentCode
            }
        break 
        case 'deleteDataDic': //删除数据字典
            list = {
                'dicIds': condition.dicIds
            }
        break 
        case 'getTaxRateList': //查询税率列表
            list = {
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize,
            }
        break 
        case 'addTaxRate': //新增税率
            list = {
                'taxName': condition.taxName,
                'taxType': condition.taxType,
                'region': condition.region,
                'deductible': condition.deductible,
                'taxLogic': condition.taxLogic,
                'taxRate': condition.taxRate
            }
        break 
        case 'modifyTaxRate': //修改税率
            list = {
                'taxRateId': condition.taxRateId,
                'taxName': condition.taxName,
                'taxType': condition.taxType,
                'region': condition.region,
                'deductible': condition.deductible,
                'taxLogic': condition.taxLogic,
                'taxRate': condition.taxRate
            }
        break 
        case 'deleteTaxRate': //删除税率
            list = {
                'taxRateIds': condition.taxRateIds
            }
        break 

        case 'getExchangeRateList': //查询汇率列表
            list = {
                'operatingUnit': condition.operatingUnit,
                'currencyFrom': condition.currencyFrom,
                'currencyTo': condition.currencyTo,
                'startDate': condition.startDate,
                'endDate': condition.endDate,
                'exchangeRate': condition.exchangeRate,
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize,
            }
        break 
        case 'addExchangeRate': //新增汇率
            list = {
                'operatingUnit': condition.operatingUnit,
                'currencyFrom': condition.currencyFrom,
                'currencyTo': condition.currencyTo,
                'startDate': condition.startDate,
                'endDate': condition.endDate,
                'exchangeRate': condition.exchangeRate,
                'enableFlag': condition.enableFlag,
            }
        break 
        case 'modifyExchangeRate': //修改汇率
            list = {
                'exchangeRateId': condition.exchangeRateId,
                'operatingUnit': condition.operatingUnit,
                'currencyFrom': condition.currencyFrom,
                'currencyTo': condition.currencyTo,
                'startDate': condition.startDate,
                'endDate': condition.endDate,
                'exchangeRate': condition.exchangeRate,
                'enableFlag': condition.enableFlag,
            }
        break 
        case 'deleteExchangeRate': //删除汇率
            list = {
                'exchangeRateIds': condition.exchangeRateIds
            }
        break 

        case 'getPrimaryDataList': //查询主数据列表
            list = {
                'primaryLedger': condition.primaryLedger,
                // 'secondaryLedger': condition.secondaryLedger,
                'operatingUnit': condition.operatingUnit,
                'ouCode': condition.ouCode,
                'investErpFlag': condition.investErpFlag,
                'primaryLedgerId': condition.primaryLedgerId,
                'legalEntity': condition.legalEntity,
                'region': condition.region,
                'functionalCurrency': condition.functionalCurrency,
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize,
            }
        break 
        case 'addPrimaryData': //新增主数据
            list = {
                'primaryLedger': condition.primaryLedger,
                // 'secondaryLedger': condition.secondaryLedger,
                'operatingUnit': condition.operatingUnit,
                'ouCode': condition.ouCode,
                'investErpFlag': condition.investErpFlag,
                'primaryLedgerId': condition.primaryLedgerId,
                'legalEntity': condition.legalEntity,
                'region': condition.region,
                'functionalCurrency': condition.functionalCurrency,
            }
        break 
        case 'modifyPrimaryData': //修改主数据
            list = {
                'mainDataId': condition.mainDataId,
                'primaryLedger': condition.primaryLedger,
                // 'secondaryLedger': condition.secondaryLedger,
                'operatingUnit': condition.operatingUnit,
                'ouCode': condition.ouCode,
                'investErpFlag': condition.investErpFlag,
                'primaryLedgerId': condition.primaryLedgerId,
                'legalEntity': condition.legalEntity,
                'region': condition.region,
                'functionalCurrency': condition.functionalCurrency,
            }
        break 
        case 'deletePrimaryData': //删除主数据
            list = {
                'mainDataIds': condition.mainDataIds
            }
        break 

        case 'getLoanInterestList': //查询借款贷款利率列表
            list = {
                'operatingUnit': condition.operatingUnit,
                'discountRateType': condition.discountRateType,
                'leaseItemType': condition.leaseItemType,
                'contractCurrency': condition.contractCurrency,
                'region': condition.region,
                'discountRateEffectiveFrom': condition.discountRateEffectiveFrom,
                'discountRateEffectiveTo': condition.discountRateEffectiveTo,
                'leaseTermFrom': condition.leaseTermFrom,
                'leaseTermTo': condition.leaseTermTo,
                'pageNum': condition.pageNum,
                'pageSize': condition.pageSize,
            }
        break 
        case 'addLoanInterest': //新增借款贷款利率
            list = {
                'discountRateType': condition.discountRateType,
                'operatingUnit': condition.operatingUnit,
                'contractCurrency': condition.contractCurrency,
                'region': condition.region,
                'leaseItemType': condition.leaseItemType,
                'leaseTermFrom': condition.leaseTermFrom,
                'leaseTermTo': condition.leaseTermTo,
                'discountRateEffectiveFrom': condition.discountRateEffectiveFrom,
                'discountRateEffectiveTo': condition.discountRateEffectiveTo,
                'leaseContractAmountFrom': condition.leaseContractAmountFrom,
                'leaseContractAmountTo': condition.leaseContractAmountTo,
                'discountRateSource': condition.discountRateSource,
                'discountRate': condition.discountRate 
            }
        break 
        case 'modifyLoanInterest': //修改借款贷款利率
            list = {
                'discountRateId': condition.discountRateId,
                'discountRateType': condition.discountRateType,
                'operatingUnit': condition.operatingUnit,
                'contractCurrency': condition.contractCurrency,
                'region': condition.region,
                'leaseItemType': condition.leaseItemType,
                'leaseTermFrom': condition.leaseTermFrom,
                'leaseTermTo': condition.leaseTermTo,
                'discountRateEffectiveFrom': condition.discountRateEffectiveFrom,
                'discountRateEffectiveTo': condition.discountRateEffectiveTo,
                'leaseContractAmountFrom': condition.leaseContractAmountFrom,
                'leaseContractAmountTo': condition.leaseContractAmountTo,
                'discountRateSource': condition.discountRateSource,
                'discountRate': condition.discountRate
            }
        break 
        case 'deleteLoanInterest': //删除借款贷款利率
            list = {
                'discountRateIds': condition.discountRateIds
            }
        break 

        case 'getAccountRuleList': //查询科目列表
            list = {
                'primaryLedger': condition.primaryLedger,
                'titleType': condition.titleType,
                'documentType': condition.documentType,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break 
        case 'viewAccountRule': //修改前的查看
        list = {
                'accountTitleId': condition.accountTitleId
            }
        break 
        case 'addAccountRule': //新增科目
            list = {
                'titleType': condition.titleType,
                'primaryLedger': condition.primaryLedger,
                'documentType': condition.documentType,
                'contentName': condition.contentName,
                'titleStage': condition.titleStage,
                'dcDirection': condition.dcDirection,
                'data': condition.data
            }
        break 
        case 'modifyAccountRule': //修改科目
            list = {
                'accountTitleId': condition.accountTitleId,
                'titleType': condition.titleType,
                'primaryLedger': condition.primaryLedger,
                'documentType': condition.documentType,
                'contentName': condition.contentName,
                'titleStage': condition.titleStage,
                'dcDirection': condition.dcDirection,
                'data': condition.data
            }
        break 
        case 'deleteAccountRule': //删除科目
            list = {
                'accountingTitleIds': condition.accountingTitleIds
            }
        break 
        
        case 'addAccountRuleColumn': //新增科目列
            list = {
                'accountTitleRowName': condition.accountTitleRowName
            }
        break 
        case 'deleteAccountRuleColumn': //删除科目列
            list = {
                'accountTitleRowId': condition.accountTitleRowId
            }
        break 

        case 'getSystemMappingList': //查询系统映射列表
            list = {
                'keyName': condition.keyName,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break 
        case 'addSystemMapping': //新增映射
            list = {
                'outsideMapName': condition.outsideMapName,
                'outsideMapCode': condition.outsideMapCode,
                'primaryLedgerInput': condition.checkedInputs.includes('primaryLedgerInput'),
                'ouNameInput': condition.checkedInputs.includes('ouNameInput'),
                'costCenterInput': condition.checkedInputs.includes('costCenterInput'),
                'currencyInput': condition.checkedInputs.includes('currencyInput'),
                'leaseTypeInput': condition.checkedInputs.includes('leaseTypeInput'),
                'dataSourceInput': condition.checkedInputs.includes('dataSourceInput'),
                'regionInput': condition.checkedInputs.includes('regionInput'),
                'itemInfoInput': condition.checkedInputs.includes('itemInfoInput'),
                'leaseTermInput': condition.checkedInputs.includes('leaseTermInput'),
                'leaseItemTypeInput': condition.checkedInputs.includes('leaseItemTypeInput'),
                'usefulLifeInput': condition.checkedInputs.includes('usefulLifeInput'),
                'primaryLedgerMap': condition.checkedMaps.includes('primaryLedgerMap'),
                'ouNameMap': condition.checkedMaps.includes('ouNameMap'),
                'costCenterMap': condition.checkedMaps.includes('costCenterMap'),
                'currencyMap': condition.checkedMaps.includes('currencyMap'),
                'leaseTypeMap': condition.checkedMaps.includes('leaseTypeMap'),
                'dataSourceMap': condition.checkedMaps.includes('dataSourceMap'),
                'regionMap': condition.checkedMaps.includes('regionMap'),
                'itemInfoMap': condition.checkedMaps.includes('itemInfoMap'),
                'leaseTermMap': condition.checkedMaps.includes('leaseTermMap'),
                'leaseItemTypeMap': condition.checkedMaps.includes('leaseItemTypeMap'),
                'usefulLifeMap': condition.checkedMaps.includes('usefulLifeMap'),
                // 'enableFlag': condition.enableFlag,
            }
        break 
        case 'modifySystemMapping': //修改映射
            list = {
                'outsideMapId': condition.outsideMapId,
                'outsideMapName': condition.outsideMapName,
                // 'enableFlag': condition.enableFlag,
            }
        break 
        case 'modifySystemMappingCol': //修改映射列
            list = condition
        break 
        case 'deleteSystemMapping': //删除映射
            list = {
                'outsideMapIds': condition.outsideMapIds
            }
        break 
        case 'getSystemMappingColumn': //获得table列
        list = {
                'outsideMapId': condition.outsideMapId
            }
        break 
        case 'getSystemMappingLineList': //查询系统映射行列表
            list = {
                'outsideMapId': condition.outsideMapId,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break 
        case 'addSystemMappingLine': //新增映射行
            list = condition
        break 
        case 'modifySystemMappingLine': //修改映射行
            list = condition
        break 
        case 'deleteSystemMappingLine': //删除映射行
            list = {
                'outsideMapLineIds': condition.outsideMapLineIds
            }
        break 


        //系统管理
        case 'login': //登陆
            list = {
                'account': condition.account,
                'password': condition.password
            }
        break
        
        case 'vaildUserPassword': //验证用户密码是否到3个月
            list = {
                'userId': condition.userId
            }
        break
        case 'forgetPwd': //忘记密码
            list = {
                'phone': condition.phone,
                'password': condition.password,
                'passwordRel': condition.passwordRel,
                'vaildCode': condition.vaildCode
            }
        break
        case 'changePwd': //修改密码
            list = {
                'oldPassword': condition.oldPassword,
                'newPassword': condition.newPassword,
                'newPasswordRe': condition.newPasswordRe
            }
        break
        case 'sendCode': //发送验证码
            list = {
                'phone': condition.phone,
                'action': condition.action //sms_regist--注册 sms_login--登录 sms_forget--忘记密码
            }
        break
        case 'getUserList': //查询用户列表
            list = {
                'name': condition.name,
                'roleName': condition.roleName,
                'enableFlag': condition.enableFlag,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        case 'getDetailUserInfo': //获取用户详情 
            list = {
                'userId': condition.userId
            }
        break
        case 'addUser': //新增用户
            list = {
                'account': condition.account,
                'name': condition.name,
                'email': condition.email,
                'mobile': condition.mobile,
                'password': condition.password,
                'startDate': condition.startDate,
                'endDate': condition.endDate,
                'roleId': condition.roleId,
                'enableFlag': condition.enableFlag
            }
        break
        case 'updateUser': //修改用户
            list = {
                'userId': condition.userId,
                'name': condition.name,
                'email': condition.email,
                'mobile': condition.mobile,
                'startDate': condition.startDate,
                'endDate': condition.endDate,
                'roleId': condition.roleId,
                'enableFlag': condition.enableFlag
            }
        break
        case 'deleteUser': //删除用户
            list = {
                'userId': condition.userId
            }
        break
        case 'batchDeleteUser': //批量删除用户
            list = {
                'userIds': condition.userIds
            }
        break
        case 'uploadedFile': //上传文件
            let fd = new FormData()
            fd.append('uploadedFile',condition.uploadedFile)
            list = fd
        break
        case 'uploadedValidData': //上传错误日志验证
            list = {
                errorId: condition.errorId
            }
        break
        case 'getRoleList': //查询角色列表
            list = {
                'name': condition.name,
                'code': condition.code,
                'enableFlag': condition.enableFlag,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break
        case 'getRoleUser': //查询当前角色的用户信息
            list = {
                'roleId': condition.roleId,
                'name': condition.name,
                'code': condition.code,
                'enableFlag': condition.enableFlag,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break
        case 'getRoleNoUser': //查询当前角色未拥有的用户信息
            list = {
                'roleId': condition.roleId,
                'name': condition.name,
                'code': condition.code,
                'enableFlag': condition.enableFlag,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum,
            }
        break
        case 'getRoleDetail': //角色详情
            list = {
                'roleId': condition.roleId
            }
        break
        case 'addRole': //新增角色
            list = {
                'name': condition.name,
                'enableFlag': condition.enableFlag
            }
        break
        case 'updateRole': //修改角色
            list = {
                'roleId': condition.roleId,
                'name': condition.name,
                'enableFlag': condition.enableFlag
            }
        break 
        case 'verifyRoleName': //验证角色名称是否已存在
            list = {
                'roleId': condition.roleId,
                'roleName': condition.name,
            }
        break
        case 'deleteRole': //角色详情
            list = {
                'roleId': condition.roleId
            }
        break
        case 'deleteRoleUser': //删除角色关联用户
            list = {
                'roleId': condition.roleId,
                'userId': condition.userId,
                'action': condition.action,
            }
        break
        case 'batchUpdateRoleUser': //批量更新角色关联用户
            list = {
                'roleId': condition.roleId,
                'userIds': condition.userIds,
                'action': condition.action,
            }
        break
        case 'getRoleMenu': //角色资源
            list = {
                'roleId': condition.roleId
            }
        break 
        case 'addRoleMenu': //新增角色资源
            list = {
                'roleId': condition.roleId,
                'addMenuIds': condition.addMenuIds,
                'deleteMenuIds': condition.deleteMenuIds
            }
        break
        case 'getRoleMenuButton': //获得某角色下的菜单的按钮
            list = {
                'roleId': condition.roleId,
                'menuId': condition.menuId
            }
        break  
        case 'modifyRoleMenuButton': //修改某角色下的菜单的按钮
            list = {
                'roleId': condition.roleId,
                'menuId': condition.menuId,
                'buttonIds': condition.buttonIds
            }
        break
        case 'getMenuList': //查询菜单列表
            list = {
                'keyName': condition.keyName,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break 
        case 'viewMenu': //新增菜单
            list = {
                'menuId': condition.menuId
            }
        break
        case 'addMenu': //新增菜单
            list = {
                'menuName': condition.menuName,
                'menuCode': condition.menuCode,
                'menuType': condition.menuType,
                'enableFlag': condition.enableFlag,
                'menuLink': condition.menuLink,
                'menuParentCode': condition.menuParentCode,
                'menuParentName': condition.menuParentName,
                'menuSortNum': condition.menuSortNum,
                'menuIcon': condition.menuIcon
            }
        break
        case 'modifyMenu': //修改菜单
            list = {
                'menuId': condition.menuId,
                'menuName': condition.menuName,
                'menuCode': condition.menuCode,
                'menuType': condition.menuType,
                'enableFlag': condition.enableFlag,
                'menuLink': condition.menuLink,
                'menuParentCode': condition.menuParentCode,
                'menuParentName': condition.menuParentName,
                'menuSortNum': condition.menuSortNum,
                'menuIcon': condition.menuIcon
            }
        break
        case 'deleteMenu': //删除菜单
            list = {
                'menuId': condition.menuId
            }
        break
        case 'getButtonList': //获取按钮列表
            list = {
                'menuId': condition.menuId
            }
        break 
        case 'addButton': //新增按钮
            list = {
                'menuId': condition.menuId,
                'buttonCode': condition.buttonCode,
                'buttonName': condition.buttonName,
                'enableFlag': condition.enableFlag,
            }
        break
        case 'modifyButton': //新增按钮
            list = {
                'buttonId': condition.buttonId,
                'menuId': condition.menuId,
                'buttonCode': condition.buttonCode,
                'buttonName': condition.buttonName,
                'enableFlag': condition.enableFlag,
            }
        break
        case 'deleteButton': //获取按钮列表
            list = {
                'buttonId': condition.buttonId
            }
        break
        case 'getEnumList': //查询枚举列表
            list = {
                'keyName': condition.keyName,
                'enableFlag': condition.enableFlag,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        case 'viewEnum': //查看枚举
            list = {
                'id': condition.id
            }
        break
        case 'addEnum': //新增枚举
            list = {
                'enumKey': condition.enumKey,
                'enumName': condition.enumName,
                'enumKeyValue': condition.enumKeyValue,
                'enumParentKey': condition.enumParentKey,
                'enumParentKeyValue': condition.enumParentKeyValue,
                'enumSortNumber': condition.enumSortNumber,
                'enableFlag': condition.enableFlag
            }
        break
        case 'modifyEnum': //修改枚举
            list = {
                'enumId': condition.enumId,
                'enumKey': condition.enumKey,
                'enumName': condition.enumName,
                'enumKeyValue': condition.enumKeyValue,
                'enumParentKey': condition.enumParentKey,
                'enumParentKeyValue': condition.enumParentKeyValue,
                'enumSortNumber': condition.enumSortNumber,
                'enableFlag': condition.enableFlag
            }
        break
        case 'deleteEnum': //删除枚举
            list = {
                'enumId': condition.enumId
            }
        break
        case 'getLogList': //查询日志列表 没选时间默认不传
            list = {
                'logUserName': condition.logUserName,
                // 'logRoleType': condition.logRoleType,
                'logTypeExt': condition.logType,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        case 'getLogListHasDate': //查询日志列表
            list = {
                'logUserName': condition.logUserName,
                // 'logRoleType': condition.logRoleType,
                'logTypeExt': condition.logType,
                'createTimeStart': condition.createTimeStart,
                'createTimeEnd': condition.createTimeEnd,
                'pageSize': condition.pageSize,
                'pageNum': condition.pageNum
            }
        break
        default:
        break
    }
    return list
}

// 获取接口并返回前端
const interfaceApi = {
    interfaceVal: {},
    getParams (type, condition) {
        this.interfaceVal = setNewsInterface(type, condition)
        return this.interfaceVal
    }
}

export default interfaceApi



// WEBPACK FOOTER //
// ./src/api/common/interface.js